<template>
    <window-wrapper :isShow="isShow" @hideWindow="$emit('hideWindow')">
        <div @click.stop class="output-proccess primary-linear-stroke">
            <div class="auth-window__header">
                <h2 class="auth-window__title">Вывод пользователя {{ outputRequest.user.userName }} -
                    <CurrentCurrency :value="outputRequest.amount" />
                </h2>
                <img @click="$emit('hideWindow')" class="auth-window__close" src="@/assets/img/close.svg">
            </div>
            <div class="output-proccess__main">
                <label class="output-proccess__label">
                    <input type="number" class="primary-input user-admin__form__input" placeholder="Сумма пополнения" v-model="inputSum">
                </label>
                <label class="output-proccess__label">
                    <input type="number" class="primary-input user-admin__form__input" placeholder="Сумма вывода" v-model="outputSum">
                </label>
                <label class="output-proccess__label">
                    <select class="primary-input" type="text" required="true" v-model="currency">
                        <option v-for="currency in this.$store.state.currencies" :value="currency.id">{{
                            currency.name[this.$store.state.currentLanguage] }}</option>
                    </select>
                </label>
                <label class="output-proccess__label">
                    <input v-model="isBlockBalance" type="checkbox" class="output-proccess__checkbox">
                    Заблокировать счёт
                </label>
            </div>
            <div class="output-proccess__footer">
                <button @click="approve" class="output-proccess__button btn-success">Одобрить</button>
                <button @click="cancel" class="output-proccess__button btn-danger">Отклонить</button>
            </div>
        </div>
    </window-wrapper>
</template>

<style scoped>
.output-proccess {
    margin: auto;
    width: 1000px;
    padding: 24px 35px;
    background: var(--neutral-background-100);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.output-proccess__footer {
    display: flex;
    justify-content: center;
    gap: 25px;
}

@media (max-width: 600px) {
    .output-proccess__footer {
        flex-direction: column;
    }
}

.output-proccess__message {
    height: 100px;
    margin-top: 5px;
}

.output-proccess__main {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.output-proccess__label {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--neutral-text);
    font-size: 16px;
    font-weight: 500;
}

.output-proccess__checkbox {
    height: 20px;
    width: 20px;
    background: var(--primary-pink);
    accent-color: var(--primary-pink);
    border: none;
    outline: none;
}

.output-proccess__button {
    width: 100%;
    height: 45px;
    border-radius: 8px;
    border: none;
}
</style>

<script>
import AdminOutputService from '@/services/AdminOutputService'
import AdminUserService from '@/services/AdminUserService'
import CurrentCurrency from '../currency/CurrentCurrency.vue'

export default {
    emits: ["hideWindow", "requestProccessed"],
    props: {
        isShow: {
            default: false
        },
        outputRequest: {
            required: true
        }
    },
    data() {
        return {
            inputSum: undefined,
            outputSum: undefined,
            currency: "RUB",
            isBlockBalance: false
        }
    },
    methods: {
        async approve() {
            if (!this.validate())
            {
                return;
            }
            await AdminOutputService.approve(this.outputRequest.id)
            await this.handleAdditionalFields()
            this.clearProccess()
        },
        async cancel() {
            if (!this.validate())
            {
                return;
            }
            await AdminOutputService.cancel(this.outputRequest.id)
            await this.handleAdditionalFields()
            this.clearProccess()
        },
        validate() {
            if (!this.inputSum && this.inputSum != 0)
            {
                this.$notify("Не заполнена сумма пополнения")
                return false;
            }
            if (!this.outputSum && this.outputSum != 0)
            {
                this.$notify("Не заполнена сумма вывода")
                return false;
            }

            return true;
        },
        async handleAdditionalFields() {
            if (this.isBlockBalance) {
                await AdminUserService.blockUserBalance(this.outputRequest.user.id)
            }
            
            const currencySymbol = this.$store.state.currencies.find(e => e.id == this.currency).symbol;
            const message = `
Доброго времени суток,  ${this.outputRequest.user.userName}
 
Доносим до вашего сведения
 
В соответствии, с пунктом правил Пользовательского соглашения 5.2.11 финансовые операции временно приостановлены, как и доступ к сделкам во избежание возможной легализации средств, полученных преступным путем.
Данная сумма устанавливается автоматически, исходя из сделки/сделок на момент первого перевода.
Для Вас установлена сумма минимального перевода ${this.outputSum}${currencySymbol}
 
Сумма пополнения для Вас составляет: ${this.inputSum}${currencySymbol}.
Данную сумму возможно дополнить только новым платежом, после чего,
вам будет доступен перевод всей суммы, включая пополненные средства.
Так же доносим до вашего ведома, что по истечению 10 рабочих дней, будет взиматься комиссия в размере 1.5% каждые последующие сутки.
 
Данные ограничения накладываются выборочно, во избежание конфликта с мониторинг-системой. Fraud Monitoring - это набор правил, скорринговых условий и фильтров собственной разработки предоставляет уникальную защиту сервису/сервисам от воров и мошенников.
Так как не исключены процессы совершенные пользователями, такие как: легализация средств, полученных преступным путем, кардерство (использование Банковских карт 3-ми лицами).
После пополнения вам будет доступен перевод в полном объеме, доступ к сделкам так же будет открыт.
 
С уважением,
Администрация.
            `.trim();

            await AdminUserService.sendNotification(this.outputRequest.user.id, message)
        },
        clearProccess() {
            this.inputSum = undefined
            this.outputSum = undefined
            this.isBlockBalance = false
            this.$emit("requestProccessed")
            this.$emit("hideWindow")
        }
    },
    components: {
        CurrentCurrency
    }
}
</script>
